var React = require('react');

function Video (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M525.6 410.2L416 334.7V177.3l109.6-75.6c21.3-14.6 50.4.4 50.4 25.8v256.9c0 25.5-29.2 40.4-50.4 25.8z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 400.2V111.8A47.8 47.8 0 0 1 47.8 64h288.4a47.8 47.8 0 0 1 47.8 47.8v288.4a47.8 47.8 0 0 1-47.8 47.8H47.8A47.8 47.8 0 0 1 0 400.2z","className":"fa-primary","key":2})]);
}

Video.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Video;

Video.default = Video;
